(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["decoded-blog-world"] && !Shopify.designMode) return;
  try {
    
  function initDecodedTitleFilters(root) {
    var forms = (root || document).querySelectorAll('[data-decoded-title-filter]');
    forms.forEach(function (form) {
      if (form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';

      var search = form.querySelector('[data-title-search]');
      var select = form.querySelector('[data-title-select]');
      var go = form.querySelector('[data-title-go]');
      if (!select) return;

      var allOptions = Array.prototype.slice.call(select.options).map(function (opt) {
        return {
          value: opt.value,
          label: (opt.getAttribute('data-label') || opt.textContent || '').trim(),
          text: (opt.textContent || '').trim(),
          isAll: opt === select.options[0]
        };
      });

      function rebuild(filterText) {
        var q = (filterText || '').toLowerCase().trim();
        var current = select.value;
        select.innerHTML = '';
        allOptions.forEach(function (item) {
          if (!item.isAll && q && item.label.toLowerCase().indexOf(q) === -1 && item.text.toLowerCase().indexOf(q) === -1) {
            return;
          }
          var opt = document.createElement('option');
          opt.value = item.value;
          opt.textContent = item.text;
          if (item.label) opt.setAttribute('data-label', item.label);
          select.appendChild(opt);
        });
        if (current) {
          select.value = current;
          if (select.value !== current && select.options.length) {
            select.selectedIndex = 0;
          }
        }
      }

      function navigate() {
        var url = select.value;
        if (url) window.location.assign(url);
      }

      if (search) {
        search.addEventListener('input', function () {
          rebuild(search.value);
        });
        search.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            if (select.options.length > 1 && search.value.trim()) {
              select.selectedIndex = 1;
            }
            navigate();
          }
        });
      }

      select.addEventListener('change', navigate);
      if (go) go.addEventListener('click', navigate);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        navigate();
      });
    });
  }

  initDecodedTitleFilters(document);
  document.addEventListener('shopify:section:load', function (event) {
    initDecodedTitleFilters(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["decoded-library"] && !Shopify.designMode) return;
  try {
    
  function initializeDecodedCarousels(root) {
    var carousels = root.querySelectorAll('[data-decoded-carousel]');

    carousels.forEach(function (carousel) {
      if (carousel.dataset.carouselReady === 'true') return;

      var track = carousel.querySelector('[data-carousel-track]');
      var previous = carousel.querySelector('[data-carousel-previous]');
      var next = carousel.querySelector('[data-carousel-next]');
      var firstCard = carousel.querySelector('[data-carousel-card]');

      if (!track || !previous || !next || !firstCard) return;

      carousel.dataset.carouselReady = 'true';

      function updateControls() {
        var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
      }

      function move(direction) {
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 0);
        var step = (firstCard.getBoundingClientRect().width + gap) * 2;
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: direction * step, behavior: reducedMotion ? 'auto' : 'smooth' });
      }

      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(updateControls); }, { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
    });
  }

  initializeDecodedCarousels(document);
  document.addEventListener('shopify:section:load', function (event) {
    initializeDecodedCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["decoded-series"] && !Shopify.designMode) return;
  try {
    
  function initDecodedGalleries(root) {
    var galleries = (root || document).querySelectorAll('[data-decoded-gallery]');
    galleries.forEach(function (gallery) {
      if (gallery.dataset.galleryReady === 'true') return;
      var track = gallery.querySelector('[data-gallery-track]');
      var previous = gallery.querySelector('[data-gallery-previous]');
      var next = gallery.querySelector('[data-gallery-next]');
      var firstCard = gallery.querySelector('[data-gallery-card]');
      if (!track || !previous || !next || !firstCard) return;
      gallery.dataset.galleryReady = 'true';

      function updateControls() {
        var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
      }

      function move(direction) {
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 0);
        var step = (firstCard.getBoundingClientRect().width + gap) * 2;
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: direction * step, behavior: reduced ? 'auto' : 'smooth' });
      }

      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(updateControls); }, { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
    });
  }

  initDecodedGalleries(document);
  document.addEventListener('shopify:section:load', function (event) {
    initDecodedGalleries(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
